import React, { useEffect } from 'react';

import Footer from './views/Footer';

import { ModalFormToggler } from './sharedData/ModalFormToggler'; 

import './App.css';

import PageForm from './views/PageForm';
import Study from './views/Study';

import { Route, HashRouter as Router, Routes } from "react-router-dom";

import TagManager from 'react-gtm-module';

function App() {

  useEffect(() => {
    const tagManagerArgs = {
      gtmId: 'GTM-W9H2R8'  // GTM ID
    };

    TagManager.initialize(tagManagerArgs);
  }, []);

  return (
    <div className="App">
      <Router>
        <Routes>
          <Route exact path="/" element={
            <ModalFormToggler>
            <PageForm/>
            <Footer/>
          </ModalFormToggler>
          } />
          <Route exact path="/estudobf2024" element={<Study/>}  />
        </Routes>
      </Router>
    </div>
  );
}

export default App;
